import Resolution from 'engine/Resolution.js';
import {
    setAllTrackSteps} from 'actions/index.js';

export const updateStepRedux = (sequencerEngine, step, stepNumber, position, track, resolution, displayResolution, toggled=true) => {
    let state = sequencerEngine.state;
    let _stepNumber = displayResolution.transformStepAtResolution2(stepNumber + position, resolution);
    stepNumber = Math.floor(_stepNumber);
    position = _stepNumber - stepNumber
    let trackNumber = track.subSequence.isTrack ? track.subSequence.id : track.id;

    let trackSteps = [... (state.tracks.trackSteps[trackNumber] || [])];
    let trackFills = {... state.tracks.trackFills[trackNumber]};
    let trackStepIds = {... state.tracks.trackStepIds[trackNumber]};
    let trackPianoRollSteps = state.tracks.trackPianoRollSteps[trackNumber] || {};
    let trackPianoRollPositions = {... state.tracks.trackPianoRollPositions[trackNumber]}
    let trackPianoRollDurations = state.tracks.trackPianoRollDurations[trackNumber] || {};
    let trackPatternSteps = state.tracks.trackPatternSteps[trackNumber] || {};
    trackPianoRollSteps[step.transpose] = {... trackPianoRollSteps[step.transpose]};
    trackPianoRollPositions[step.transpose] = {... trackPianoRollPositions[step.transpose]};
    trackPianoRollDurations[step.transpose] = {... trackPianoRollDurations[step.transpose]};
    trackFills = trackFills || new Array(trackSteps.length).fill(false);

    trackSteps[stepNumber] = toggled;
    trackStepIds[stepNumber] = step;
    trackPatternSteps[track.currentPattern] = [... trackSteps];

    trackPianoRollSteps[step.transpose][stepNumber] = true;


    trackPianoRollPositions[step.transpose][stepNumber] = position;

    let myBaseResolution = new Resolution(16, false);
    trackPianoRollDurations[step.transpose][stepNumber] = resolution.transformStepAtResolution2(
        step.duration, myBaseResolution);
    for (let i=0; i < step.duration; i++) {
        trackFills[(i + stepNumber) % trackSteps.length] = true;
    }

    sequencerEngine.store.dispatch(
        setAllTrackSteps(
            track.id,
            trackSteps,
            trackPianoRollSteps,
            trackFills,
            trackStepIds,
            trackPianoRollPositions,
            trackPianoRollDurations,
            trackPatternSteps,
        ));
};
